import type { NonNullableAlertArea } from 'src/types';

export const getDefaultAlertAreaId = (alertAreas: NonNullableAlertArea[]) =>
  alertAreas[0]?.id;
